import { Container } from 'hypo-container';
import { getDecorators } from '@estee/elc-service';
import { HttpTransport } from '@estee/elc-http-transport';
import { ContentApiSdk } from '~api/ContentApiSdk';
import { ConfigStore } from '~setup/ConfigStore';
import { ContentService } from './ContentService';
import { ServiceBusController } from './ServiceBusController';
import { ContentBlockViewController } from '~controllers/ContentBlockViewController';
import { BasicToutViewController } from '~controllers/BasicToutViewController';
import { VtoFoundationOverlayViewController } from '~controllers/VtoFoundationOverlayViewController';
import { VideoToutViewController } from '~controllers/VideoToutViewController';
import { VideoToutYoutubeViewController } from '~controllers/VideoToutYoutubeViewController';
import { ThirdPartyToutViewController } from '~controllers/ThirdPartyToutViewController';
import { ContentRepository } from '~repositories/ContentRepository';
import { ProductRepository } from '~repositories/ProductRepository';
import { Node } from '~domain/entities/Node';
import { VtoFoundationQrCodeOverlayViewController } from '~controllers/VtoFoundationQrCodeOverlayViewController';
import type { IAppConfig } from '@estee/elc-universal-utils';
import serviceNames from '~setup/ContentService';
import { ELCLogger } from '@estee/elc-logging';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

const { name, version } = __serviceInfo__;

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.httpTransport, (c) => {
        const configStore = c.get(serviceNames.configStore);
        const httpTransport = new HttpTransport();
        httpTransport.setBaseUrl(configStore.baseUrl);

        return httpTransport;
    })
    .register(serviceNames.contentApiSdk, (c) => {
        const configStore = c.get(serviceNames.configStore);
        const httpTransport = c.get(serviceNames.httpTransport);
        const config = {
            businessUnitId: configStore.config.businessUnitId,
            httpTransport
        };

        return new ContentApiSdk(config);
    })
    .register(
        serviceNames.serviceBusController,
        (c) => new ServiceBusController(c.get(serviceNames.contentRepository))
    )
    .register(
        serviceNames.contentService,
        (c) =>
            new ContentService((config: IAppConfig) => {
                setConfig(config);

                c.get(serviceNames.serviceBusController);
            })
    )
    .register(serviceNames.contentBlockViewController, () => new ContentBlockViewController())
    .register(serviceNames.contentRepository, () => new ContentRepository())
    .register(serviceNames.productRepository, () => new ProductRepository())
    .register(serviceNames.contentNode, () => new Node())
    .register(serviceNames.basicToutViewController, () => new BasicToutViewController())
    .register(
        serviceNames.vtoFoundationOverlayViewController,
        () => new VtoFoundationOverlayViewController()
    )
    .register(serviceNames.videoToutViewController, () => new VideoToutViewController())
    .register(
        serviceNames.videoToutYoutubeViewController,
        () => new VideoToutYoutubeViewController()
    )
    .register(serviceNames.thirdPartyToutViewController, () => new ThirdPartyToutViewController())
    .register(
        serviceNames.vtoFoundationQrCodeOverlayViewController,
        () => new VtoFoundationQrCodeOverlayViewController()
    )
    .register(
        serviceNames.logger,
        () =>
            new ELCLogger({
                serviceName: name,
                serviceVersion: version
            })
    );

const { lazyInject } = getDecorators(diContainer);
export { lazyInject };
